@if (isLoading()) {
<app-spinner data-test-id="challenge-live-spinner"></app-spinner>
} @else {
<div class="challenge-live-content">
  <app-card [size]="'large'" [fullHeight]="true">
    <app-title-section
      title="{{ 'challenges.challenges' | translate }}"
      [size]="3"
      [backButton]="true"
      [spacingBottom]="TitleSpacing.LARGE"
      (handlePressBack)="goBack()"
    >
    </app-title-section>
    <div class="challenge-overview">
      <app-title-section
        [title]="challenge?.title"
        [subTitle]="groupChallengeDates"
        [size]="1"
        [backButton]="false"
        [spacingBottom]="0"
      >
      </app-title-section>
      @if (challengeStatus() === groupChallengeStatus.ENDED) {
      <app-chip
        [color]="ChipColor.NAVY"
        [size]="ChipSize.LARGE"
        [value]="challengeStatus()"
        data-test-id="challenge-live-chip-ended"
      ></app-chip>
      } @else {
      <app-chip
        [color]="ChipColor.HYPER_BLUE"
        [size]="ChipSize.LARGE"
        [value]="challengeStatus()"
        data-test-id="challenge-live-chip-active"
      ></app-chip>
      }
    </div>

    <app-title-section
      class="challenge-information-section"
      title="{{ 'groupChallenges.challengeInfo' | translate }}"
      [size]="2"
      [body]="challenge?.title"
      [backButton]="false"
      [spacingBottom]="TitleSpacing.X_LARGE"
    >
    </app-title-section>

    <app-title-section
      title="{{
        isLiveChallenge()
          ? ('groupChallenges.topTeams' | translate)
          : ('groupChallenges.finalScores' | translate)
      }}"
      [size]="2"
      [backButton]="false"
      [spacingBottom]="TitleSpacing.MEDIUM"
    >
    </app-title-section>
    <div class="team-view-container">
      @if (hasNoParticipants()) {
        <p data-test-id="challenge-live-no-participants">{{ 'groupChallenges.noParticipants' | translate }}</p>
      } @else {
        @for (team of teams(); track team) {
          <app-challenge-leaderboard-card
            [team]="team"
            data-test-id="challenge-live-leaderboard-card"
          ></app-challenge-leaderboard-card>
        }
      }
    </div>
  </app-card>
</div>
}
